import { convertStateToParams } from "../utils";
import { authApi } from "./auth";
import { mainServiceURL } from "./defines";

export const plansApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchPlans: builder.query({
      query: (gridState) => {
        const processedState = convertStateToParams(gridState);

        return {
          url: mainServiceURL + "/plans",
          method: "GET",
          params: processedState,
        };
      },
      providesTags: ["Plan"],
    }),
  }),
});

export const { useFetchPlansQuery } = plansApi;
